import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import {   ProductSearchInputOrder, ProductsSearchListResponse, ProductVariantResponse } from "../../models";
import { HttpService } from "./http.service";
import { Observable, } from "rxjs";
import { ProductSearchInput } from "@sgm-frontend/core";

@Injectable({
  providedIn: 'root'
})
export class AutoCompleteService extends HttpService<string | ProductSearchInputOrder, ProductVariantResponse|ProductsSearchListResponse> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'product-variant');
  }

  

  getProductVarientAutoComplete(payload: { query: string; is_refurbished?: boolean }): Observable<ProductVariantResponse> {
    return this.autoCompleteSearch(payload, '') as unknown as Observable<ProductVariantResponse>;
  }
    searchVariants(input: ProductSearchInput): Observable<ProductsSearchListResponse> {
      return this.searchAllPaged(input) as Observable<ProductsSearchListResponse>;
    }
  
  
}
